// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media print {\n.document-viewer[data-v-2e190e4e] {\n    display: none;\n}\n}\n.document-viewer[data-v-2e190e4e] {\n  background: #2a2a2e;\n  height: 100vh;\n  width: 100vw;\n  margin: 0;\n  padding: 0;\n  border: none;\n}\n.document-viewer iframe[data-v-2e190e4e] {\n  height: 99vh;\n  width: 100vw;\n  margin: 0;\n  padding: 0;\n  border: none;\n}", ""]);
// Exports
module.exports = exports;
